import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
};

/** Минимальный индикатор при подгрузке чанка маршрута (React.lazy). */
export function RouteFallback({ className }: Props) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Загрузка"
      className={cn(
        'flex min-h-[40vh] w-full flex-1 items-center justify-center text-muted-foreground',
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
    </div>
  );
}
